import React from "react";
import { useNavigate } from "react-router-dom";
import "./HomeDashboard.css"; 

// import insight360Logo from './assets/insight360.png';
// import darwinboxLogo from './assets/darwinbox.png';
// import stackboxLogo from './assets/stackbox.png';
// import ownitLogo from './assets/ownit.png';

const apps = [
  {
    name: "Insight360",
    subtitle: "Market Insights",
    icon: "https://cdn.jsdelivr.net/npm/bootstrap-icons@1.10.5/icons/lightbulb.svg",
    color: "linear-gradient(135deg, #ffe066 60%, #fffbe6 100%)",
    action: "profile"
  },
  {
    name: "Darwinbox",
    subtitle: "HR Portal",
    icon: "https://cdn.jsdelivr.net/npm/bootstrap-icons@1.10.5/icons/person-badge.svg",
    color: "linear-gradient(135deg, #74c0fc 60%, #e3f2fd 100%)",
    action: "https://awl.darwinbox.in/"
  },
  {
    name: "Store Locator",
    subtitle: "Locate Own Brands",
    icon: "https://cdn.jsdelivr.net/npm/bootstrap-icons@1.10.5/icons/bar-chart-line.svg",
    color: "linear-gradient(135deg, #b2f2bb 60%, #e6fcf5 100%)",
    action: "https://apps-stackbox.adaniwilmar.in/"
  },
  {
    name: "OwnIt",
    subtitle: "Support Desk",
    icon: "https://cdn.jsdelivr.net/npm/bootstrap-icons@1.10.5/icons/life-preserver.svg",
    color: "linear-gradient(135deg, #ff8787 60%, #fff0f0 100%)",
    action: "https://ownit.awl.in/"
  }
];

const newsItems = [
  {
    id: 2,
    category: "Finance",
    title: "AWL posts record Q3 profits driven by strong demand",
    imageUrl: "https://economictimes.indiatimes.com/thumb/msid-122615647,width-600,height-400,quality-90,overlay-etmarkets/photo.jpg"
  },
   {
    id: 1,
    category: "Award",
    title: "Fortune Rice Bran Oil voted 'Product of the Year'",
    imageUrl: "https://upload.wikimedia.org/wikipedia/commons/6/6e/The-awl-logo.png"
  },
  {
    id: 4,
    category: "Expansion",
    title: "Company expands its distribution network in Eastern India",
    imageUrl: "https://economictimes.indiatimes.com/thumb/msid-122615647,width-600,height-400,quality-90,overlay-etmarkets/photo.jpg"
  },
 
  
  {
    id: 3,
    category: "Sustainability",
    title: "New initiative launched to reduce carbon footprint",
    imageUrl: "https://economictimes.indiatimes.com/thumb/msid-124095506,width-600,height-400,quality-90,overlay-etmarkets/photo.jpg"
  },
  
  
];


export default function HomeDashboard() {
  const navigate = useNavigate();

  const handleAppClick = (app) => {
    if (app.action === "insight") {
      navigate("/"); 
    } else if (app.action === 'profile') {
      navigate("/profile"); 
    } else if (app.action.startsWith('http')) {
      window.open(app.action, "_blank");
    }
  };

  return (
    <div className="home-dashboard-bg">
      <header className="sticky-top-header">
        <div className="portal-branding">
          <h1 className="portal-title">AWLOne</h1>
          <div className="profile-icon-container" onClick={() => handleAppClick({ action: 'profile' })}>
            <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path><circle cx="12" cy="7" r="4"></circle></svg>
          </div>
        </div>
      </header>

      <main className="main-content-area">
        <div className="news-section">
          <h2 className="section-title">Latest Updates</h2>
          <div className="marquee-wrapper">
            <div className="marquee-inner">
              {newsItems.map(item => (
                <div className="news-card modern-news-card marquee-card" key={item.id}>
                  <img src={item.imageUrl} alt={item.title} className="news-card-img" />
                  <div className="modern-news-overlay"></div>
                  <div className="modern-news-content">
                    <span className="modern-news-category">{item.category}</span>
                    <p className="modern-news-title">{item.title}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>

        <div className="apps-section">
          <h2 className="section-title">Our Apps</h2>
          <div className="dashboard-apps-container two-column">
            {apps.map((app) => (
              <div
                className="dashboard-app-module modern-app-card"
                key={app.name}
                onClick={() => handleAppClick(app)}
                style={{ background: app.color, boxShadow: "0 4px 24px rgba(0,0,0,0.10)", borderRadius: 20, padding: '1.5rem 1rem', transition: 'transform 0.2s, box-shadow 0.2s' }}
              >
                <div className="dashboard-app-icon-wrapper" style={{ background: "rgba(255,255,255,0.85)", borderRadius: 16, width: 64, height: 64, marginBottom: 16, display: 'flex', alignItems: 'center', justifyContent: 'center', boxShadow: '0 2px 8px rgba(0,0,0,0.07)' }}>
                  <img src={app.icon} alt={`${app.name} icon`} className="app-logo-img" style={{ width: 40, height: 40 }} />
                </div>
                <div className="dashboard-app-title" style={{ fontWeight: 700, fontSize: '1.15rem', color: '#222', marginBottom: 4 }}>{app.name}</div>
                <div className="dashboard-app-subtitle" style={{ fontSize: '0.95rem', color: '#555', fontWeight: 500 }}>{app.subtitle}</div>
              </div>
            ))}
          </div>
        </div>
      </main>
    </div>
  );
}